import Session from './session'

export default class ConfigAPI {

  static get PREFIX () {
    return Session.HOST + '/api/config/'
  }

  /**
  * 設定一覧
  */
  static get () {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'get')
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }

  /**
  * 設定更新
  */
  static update (data) {
    const s = new Session()
    return s.ins.post(this.PREFIX + 'update', data)
      .then(res => {
        // success
        return res
      })
      .catch(error => {
        // error
        return Promise.reject(error || 'ERROR')
      })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/api/config-api.js